// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-type[data-v-6a8286c7]{position:absolute;left:-14px;top:3px;font-weight:bolder;font-size:16px;white-space:nowrap}.customer-type-customer[data-v-6a8286c7]{top:-3px}", ""]);
// Exports
module.exports = exports;
